import { render, staticRenderFns } from "./Detran.vue?vue&type=template&id=f25bedf2&scoped=true&"
import script from "./Detran.vue?vue&type=script&lang=js&"
export * from "./Detran.vue?vue&type=script&lang=js&"
import style0 from "./Detran.vue?vue&type=style&index=0&id=f25bedf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f25bedf2",
  null
  
)

export default component.exports